import { IEndpoint } from "../models/IEndpoint";

export const FetchUtil = {
  async sendMessage(
    endpoint: IEndpoint | null,
    body?: unknown,
    cacheStrategy: "default" | "no-store" | "reload" | "no-cache" |
      "force-cache" | "only-if-cached" | undefined = "default",
    encode = true
  ): Promise<unknown> {
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    let init: RequestInit = {
      cache: cacheStrategy,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      method: endpoint.method
    };

    if (body) {
      if (init.method !== "GET") {
        if (encode){
          init.headers = {
            "Content-Type": "application/json",
            "Wy-Encoded" : "1"
          };
          init.body = JSON.stringify({data: this.encodeRequestBody(body)});
        } else {
          init.headers = {
            "Content-Type": "application/json",
            "Wy-Encoded" : "0"
          };
          init.body = JSON.stringify(body);
        }
      } else {
        console.warn("Cannot send body with GET request", body);
      }
    }
    // console.info(`Fetching: ${endpoint.url}`);

    return fetch(endpoint.url, init)
      .then(response => response.json())
      .catch(error => {
        console.error(error);

        return [];
      });
  },
  encodeRequestBody(body: unknown): string {
    return btoa(
      unescape(
        encodeURIComponent(
          JSON.stringify(body)
        )
      )
    );
  }
};
